import { loadStripe } from "@stripe/stripe-js";

const initStripe = async () => {
  const stripe = await loadStripe("pk_live_T5LmhtRHhs3OOfjOfn6t7ePX00bnOJV2Dx");

  const button = document.getElementById("stripe-checkout");
  if (button === null) return;
  const urlString = window.location.href;
  const url = new URL(urlString);
  const stripeCheckoutSessionID = url.searchParams.get("sessionID");

  button.addEventListener("click", async () => {
    const result = await stripe?.redirectToCheckout({
      sessionId: String(stripeCheckoutSessionID),
    });
    console.error(result?.error);
  });
};

export default () => {
  initStripe();
};
